import { Component, OnInit } from '@angular/core';
import {AuthorizationService} from './authorization.service';
import {NgForm} from '@angular/forms';
import { EmailModel } from './login.model';


@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  providers: [AuthorizationService],
  styleUrls: ['./reset-password.component.less']
})
export class ResetPasswordComponent implements OnInit {
  emailModel = new EmailModel();

  showInfo = false;
  showInfoWrong = false;

  constructor(private authorizationService: AuthorizationService) { }

  ngOnInit() {
  }

  sendAnEmail(form: NgForm, isValid: boolean) {

    if ( isValid ) {
      this.authorizationService.forgotPassword(form.value.email)
        .subscribe(
          (response) => {
            console.log(response);
            if (response === 200) {
              this.showInfo = true;
              this.showInfoWrong = false;
            }
          },
          (error) => {
            console.log(error);
            if (error === 400) {
              this.showInfoWrong = true;
            }
          }
        );
    }
  }

}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/authorization/reset-password.component.ts